import { JSX } from "react";

import { Components } from "@/app/(components)/_components/Components";
import AddZone from "@/app/(components)/specifics/configurator/Configurator/ui/EditPanel/components/AddZone/AddZone";
import SaveZonePreset from "@/app/(components)/specifics/configurator/Configurator/ui/EditPanel/components/SaveZonePreset/SaveZonePreset";
import ExportInsole from "@/app/(components)/specifics/configurator/Configurator/ui/ExportInsole/ExportInsole";
import AddInsoleModel from "@/app/(components)/specifics/library/Library/components/AddInsoleModel/AddInsoleModel";
import InsoleDetail from "@/app/(components)/specifics/library/Library/components/InsoleDetail/InsoleDetail";
import AddInsolePair from "@/app/(components)/specifics/patients/Patients/components/AddInsolePair/AddInsolePair";
import AddPatient from "@/app/(components)/specifics/patients/Patients/components/AddPatient/AddPatient";
import EditInsolePair from "@/app/(components)/specifics/patients/Patients/components/EditInsolePair/EditInsolePair";
import EditPatient from "@/app/(components)/specifics/patients/Patients/components/EditPatient/EditPatient";
import PatientDetail from "@/app/(components)/specifics/patients/Patients/components/PatientDetail/PatientDetail";
import Settings from "@/app/(components)/specifics/settings/Settings/Settings";
import AddUser from "@/app/(components)/specifics/users/Users/components/AddUser/AddUser";
import EditUser from "@/app/(components)/specifics/users/Users/components/EditUser/EditUser";

export class ComponentFactory {
  public static create(componentName: Components, props?: any): JSX.Element | null {
    switch (componentName) {
      case Components.SETTINGS:
        return <Settings {...props} />;
      case Components.ADD_USER:
        return <AddUser {...props} />;
      case Components.EDIT_USER:
        return <EditUser {...props} />;
      case Components.ADD_PATIENT:
        return <AddPatient {...props} />;
      case Components.EDIT_PATIENT:
        return <EditPatient {...props} />;
      case Components.ADD_INSOLE_PAIR:
        return <AddInsolePair {...props} />;
      case Components.EDIT_INSOLE_PAIR:
        return <EditInsolePair {...props} />;
      case Components.PATIENT_INFO:
        return <PatientDetail {...props} />;
      case Components.ADD_ZONE:
        return <AddZone {...props} />;
      case Components.SAVE_ZONE_PRESET:
        return <SaveZonePreset {...props} />;
      case Components.EXPORT_INSOLE:
        return <ExportInsole {...props} />;
      case Components.ADD_INSOLE_MODEL:
        return <AddInsoleModel {...props} />;
      case Components.EDIT_INSOLE_MODEL:
        return <InsoleDetail {...props} />;
      default:
        throw new Error(`Component not found: ${componentName}`);
    }
  }
}
